import React from 'react';

const LabelSocialMediaIcon = ({ label, icon, link }) => (
  <div
    onClick={() => window.open(link, '_blank')}
    className="flex justify-between items-center gap-2 py-4 px-6 text-gray-800 text-base font-medium mr-2 rounded-xl border border-gray-200 cursor-pointer"
  >
    {icon} {label}
  </div>
);

export default LabelSocialMediaIcon;
